import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Listings from "@/pages/Listings";
import ListingDetail from "@/pages/ListingDetail";
import Categories from "@/pages/Categories";
import CategoryPage from "@/pages/CategoryPage";
import Pricing from "@/pages/Pricing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import ListingForm from "@/pages/ListingForm";
import Admin from "@/pages/Admin";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Checkout from "@/pages/Checkout";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import VerifyEmail from "@/pages/VerifyEmail";
import Claim from "@/pages/Claim";
import Settings from "@/pages/Settings";
import Contact from "@/pages/Contact";
import FAQ from "@/pages/FAQ";
import Privacy from "@/pages/Privacy";
import Cookie from "@/pages/Cookie";
import Terms from "@/pages/Terms";
import CityLanding from "@/pages/CityLanding";
import CategoryCityLanding from "@/pages/CategoryCityLanding";
import CookieBanner from "@/components/CookieBanner";
import ScrollToTop from "@/components/ScrollToTop";
import { HelmetProvider } from "react-helmet-async";

function Layout({ children }) {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-black text-white">
      <HelmetProvider>
        <AuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<Layout><Home /></Layout>} />
              <Route path="/annunci" element={<Layout><Listings /></Layout>} />
              <Route path="/annunci/:id" element={<Layout><ListingDetail /></Layout>} />
              <Route path="/categorie" element={<Layout><Categories /></Layout>} />
              <Route path="/categoria/:slug" element={<Layout><CategoryPage /></Layout>} />
              <Route path="/prezzi" element={<Layout><Pricing /></Layout>} />
              <Route path="/contatti" element={<Layout><Contact /></Layout>} />
              <Route path="/faq" element={<Layout><FAQ /></Layout>} />
              <Route path="/privacy" element={<Layout><Privacy /></Layout>} />
              <Route path="/cookie" element={<Layout><Cookie /></Layout>} />
              <Route path="/termini" element={<Layout><Terms /></Layout>} />
              <Route path="/professionisti-affitti-brevi/:city" element={<Layout><CityLanding /></Layout>} />
              <Route path="/:category/:city" element={<Layout><CategoryCityLanding /></Layout>} />
              <Route path="/login" element={<Layout><Login /></Layout>} />
              <Route path="/registrati" element={<Layout><Register /></Layout>} />
              <Route path="/recupera-password" element={<Layout><ForgotPassword /></Layout>} />
              <Route path="/reimposta-password" element={<Layout><ResetPassword /></Layout>} />
              <Route path="/verifica-email" element={<Layout><VerifyEmail /></Layout>} />
              <Route path="/rivendica" element={<Layout><Claim /></Layout>} />
              <Route path="/dashboard" element={<ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>} />
              <Route path="/dashboard/impostazioni" element={<ProtectedRoute><Layout><Settings /></Layout></ProtectedRoute>} />
              <Route path="/dashboard/nuovo" element={<ProtectedRoute><Layout><ListingForm /></Layout></ProtectedRoute>} />
              <Route path="/dashboard/:id/modifica" element={<ProtectedRoute><Layout><ListingForm /></Layout></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute adminOnly><Layout><Admin /></Layout></ProtectedRoute>} />
              <Route path="/pagamento/successo" element={<Layout><PaymentSuccess /></Layout>} />
              <Route path="/pagamento/annullato" element={<Layout><PaymentCancel /></Layout>} />
              <Route path="/checkout" element={<ProtectedRoute><Layout><Checkout /></Layout></ProtectedRoute>} />
            </Routes>
            <CookieBanner />
          </BrowserRouter>
          <Toaster position="top-right" theme="dark" />
        </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
